module.exports = __webpack_public_path__ + "img/krathong_3.035532a0.png";